/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiAlbumCollectionsIdAlbumsMutationResponse, DeleteApiAlbumCollectionsIdAlbumsPathParams, DeleteApiAlbumCollectionsIdAlbumsQueryParams, DeleteApiAlbumCollectionsIdAlbums400, DeleteApiAlbumCollectionsIdAlbums401, DeleteApiAlbumCollectionsIdAlbums403, DeleteApiAlbumCollectionsIdAlbums404, DeleteApiAlbumCollectionsIdAlbums500 } from "../../types/DeleteApiAlbumCollectionsIdAlbums.ts";
import { deleteApiAlbumCollectionsIdAlbumsMutationResponseSchema } from "../../zod/AlbumCollectionSchemas/deleteApiAlbumCollectionsIdAlbumsSchema.ts";

function getDeleteApiAlbumCollectionsIdAlbumsUrl({ id }: { id: DeleteApiAlbumCollectionsIdAlbumsPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/album-collections/${id}/albums` as const }  
  return res
}

/**
 * @summary Удаление альбомов из выпуска
 * {@link /api/album-collections/:Id/albums}
 */
export async function deleteApiAlbumCollectionsIdAlbums({ id, params }: { id: DeleteApiAlbumCollectionsIdAlbumsPathParams["Id"]; params: DeleteApiAlbumCollectionsIdAlbumsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiAlbumCollectionsIdAlbumsMutationResponse, ResponseErrorConfig<DeleteApiAlbumCollectionsIdAlbums400 | DeleteApiAlbumCollectionsIdAlbums401 | DeleteApiAlbumCollectionsIdAlbums403 | DeleteApiAlbumCollectionsIdAlbums404 | DeleteApiAlbumCollectionsIdAlbums500>, unknown>({ method : "DELETE", url : getDeleteApiAlbumCollectionsIdAlbumsUrl({ id }).url.toString(), params, ... requestConfig })  
  return deleteApiAlbumCollectionsIdAlbumsMutationResponseSchema.parse(res.data)
}